type Params = {
  x: number;
  groupX: number;
  width: number;
};

export const calcRectInfo = ({ x, groupX, width }: Params) => {
  const initPadding = 12;
  const rectTransform = -(width + initPadding) / 2;

  if (groupX + x + rectTransform < 0) {
    return {
      rectX: 10,
      rectTransform: -16,
      rectPadding: initPadding,
    };
  }

  return { rectX: x, rectTransform, rectPadding: initPadding };
};
